var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04709 11.0488L3.45725 13.7393H16.0002V15.2607H3.45725L6.04709 17.9512L5.03732 19L1.2092 15.0244C0.930267 14.7344 0.930267 14.2648 1.2092 13.9756L5.03732 10L6.04709 11.0488ZM22.7912 8.97559C23.0702 9.26558 23.0702 9.73442 22.7912 10.0244L18.9631 14L17.9533 12.9512L20.5432 10.2607H8.00021V8.73926H20.5432L17.9533 6.04883L18.9631 5L22.7912 8.97559Z",
    fill: "#4C4C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDashboard);
export default __webpack_public_path__ + "static/media/switchDashboard.d23c8074d3118f397cace5fcc972c14d.svg";
export { ForwardRef as ReactComponent };